import { Component, OnInit } from '@angular/core';
import { SetPersona, SetSkipSelection } from '@app/persona/store/personas/persona.actions';
import { select, Store } from '@ngrx/store';
import { getPersonaEntities, getSelectedPersona, State } from '@app/persona/store';
import { Persona } from '@app/persona/models';
import { BehaviorSubject, combineLatest, EMPTY, merge, Observable, Subject } from 'rxjs';
import {
    catchError,
    concatAll,
    concatMap,
    filter,
    map,
    share,
    startWith,
    take,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { PersonaPickerService } from '@app/persona/services/persona-picker.service';
import { PersonaTypes } from '@app/persona/constants/constants';

@Component({
    selector: 'app-persona-selection-page',
    templateUrl: './persona-selection-page.component.html',
    styleUrls: ['./persona-selection-page.component.scss']
})
export class PersonaSelectionPageComponent implements OnInit {

    toSelectPersona$: Observable<Persona>;
    hasToSelectPersona$: Observable<boolean>;
    confirm$ = new Subject<void>();
    excludeTypes = [PersonaTypes.FILTER];

    onSelectPersona(organisationGroupId) {
        this.personaPicker.setToSelectPersona(organisationGroupId);
        // use setTimeout to update states
        setTimeout(() => this.confirm$.next(), 0);
    }

    getConfirm$(toSelectPersona$: Observable<Persona>) {
        return this.confirm$.pipe(
            withLatestFrom(toSelectPersona$),
            tap(([_, personaToSet]) => {
                this.personaPicker.setPersona(personaToSet);
                this.navAway();
            })
        );
    }

    navAway() {
        this.store.dispatch(new SetSkipSelection(true));
        this.router.navigate(['lab-orders', 'create'], { replaceUrl: true, queryParamsHandling: 'preserve' });
    }

    constructor(
        private store: Store<State>,
        private router: Router,
        private personaPicker: PersonaPickerService
    ) {

    }

    ngOnInit() {
        this.toSelectPersona$ = this.personaPicker.toSelectPersona$;
        this.hasToSelectPersona$ = this.personaPicker.hasToSelectPersona$;
        this.getConfirm$(this.toSelectPersona$).subscribe();
    }

}
